<section class="sbnb-onboarding">
  <sbnb-signup-header [hideActions]="true"></sbnb-signup-header>

  <article class="main">
    <header>
      <h2 class="nomargin">
        We know running a short-term rental business is hard,
        {{ wizard.signupUser.first_name }}
      </h2>
    </header>
    <section class="content">
      <p>
        That is why {{ 'CORE.PRODUCT_NAME' | transloco }} is here to help. All short-term rental hosts can benefit from
        easy-to-use software that saves you time and removes the hassle from hosting.
      </p>
      <p>Before we get started, let's take a few moments to learn more about each other!</p>
      <button [disabled]="saving" mat-flat-button mat-primary class="next-step" (click)="next()">
        <mat-spinner class="button__spinner" *ngIf="saving" [diameter]="30"></mat-spinner>
        Let's go
      </button>
    </section>
  </article>

  <aside>
    <img src="/assets/images/signup/start.svg" />
  </aside>
</section>
